"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
exports.Service = {
    yanolja: 'yanolja',
    interpark: 'interpark',
    triple: 'triple',
};
